export const getPictureHTML = (attributes) => {
  const { productDetails, src } = attributes;

  return `
    <picture data-product-details='${JSON.stringify(productDetails)}' data-src='${JSON.stringify(src)}'>
      <source
          data-srcset="${src.lg}"
          media="(min-width: 1450px)"/>
      <source
          data-srcset="${src.md}"
          media="(min-width: 1025px)"/>
      <source
          data-srcset="${src.sm}"
          media="(min-width: 760px)"/>
      <source
          data-srcset="${src.xs}"
          media="(max-width: 759px)"/>
      <img
        class="swa-product-color-variant__image lazyload"
        data-src="${src.default}" src="${src.defaultLazy}"
        alt="${src.alt}"
      >
    </picture>
      `;
};

export const getProductColorsHTML = (colors) => {
  return colors.map((color) => {return `
    <div class="glide__slide">
        <div class="swa-product-color-variant">
        ${getPictureHTML(color.picture)}
        </div>
    </div>
  `;}).join('');
};

export const getProductVariantsHTML = (data) => {
  return `
    <h4>${data.title}</h4>
    <div class="swa-product-tile__carousel js-swa-product-tile-carousel">
      <div class="glide__track" data-glide-el="track">
        <div class="glide__slides">
          ${getProductColorsHTML(data.colors)}
        </div>
      </div>
      <div class="glide__arrows" data-glide-el="controls">
        <span class="glide__arrow glide__arrow--left" data-glide-dir="<">
          <span class="swa-visually-hidden">${data.arrowLeftAltText}</span>
          <img class="lazyload" data-src="/images/icons/icon-arrow-left-roll.svg" src="/images/transparent-pixel.gif" alt="${data.arrowLeftAltText}"/>
        </span>
        <span class="glide__arrow glide__arrow--right" data-glide-dir=">">
          <span class="swa-visually-hidden">${data.arrowRightAltText}</span>
          <img class="lazyload" data-src="/images/icons/icon-arrow-right-roll.svg" src="/images/transparent-pixel.gif" alt="${data.arrowRightAltText}"/>
        </span>
      </div>
    </div>`;
};


export const getCarouselBulletHTML = (data) => {
  return `
    <button 
      aria-label="${data.alt}" 
      class="glide__bullet" data-glide-dir="=${data.index}"
    ></button>
  `;
};
